import { useId, useState } from "react";
import { htRetAdiMi } from "@oasis/domain";
import { Buton, Cip, Modal, etiket } from "@/components/parcalar";
import { BOS_SAYFA, SayfaAlani, sayfaAlanlari, sayfaGecerli, type SayfaSecimi } from "@/components/pdf-sayfa";
import { cevir } from "@/lib/dil";
import { ilkHtSonucu, type HtSonuc } from "@/lib/belgeler";
import { dosyaSec } from "@/lib/veri";

/**
 * D-074 Faz 2 (K7): hidrotest sertifikasının sonucu. Kararı kişi verir (belge okunmaz): "Accepted" hattın sertifikası sayılır,
 * "Rejected" kayıtta kalır ama sayılmaz. Varsayılan "Accepted" (bugünkü davranış); dosya adı "reject" diyorsa ikisi de boş açılır
 * ve seçim yapılmadan yüklenmez. Finishing'in "Upload HT report" penceresi ve Documents'ın hidrotest kartı aynı alanı kullanır.
 */
export function HtSonucAlani({ deger, onChange, ad, disabled, etiketsiz }: { deger: HtSonuc; onChange: (s: HtSonuc) => void; ad: string | null | undefined; disabled?: boolean; etiketsiz?: boolean }) {
  const isim = useId();
  return (
    <fieldset className="mt-3" disabled={disabled}>
      <legend className={etiketsiz ? "sr-only" : etiket}>{cevir("Certificate result")}</legend>
      <label className="flex items-start gap-2 text-sm"><input type="radio" name={isim} className="mt-0.5" checked={deger === "kabul"} onChange={() => onChange("kabul")} /> <span>{cevir("Accepted: counts as the line's hydrotest certificate")}</span></label>
      <label className="mt-1 flex items-start gap-2 text-sm"><input type="radio" name={isim} className="mt-0.5" checked={deger === "ret"} onChange={() => onChange("ret")} /> <span>{cevir("Rejected: kept on record, not counted for the line")}</span></label>
      {htRetAdiMi(ad) && <p className="mt-1 text-xs text-warn">{cevir("The file name says REJECTED. Check the certificate and choose the result.")}</p>}
    </fieldset>
  );
}

/**
 * Finishing'in hidrotest sertifikası yükleme penceresi (`NdtYuklemePenceresi` kalıbı): Select PDF · Partial + sayfa · "Certificate
 * result" · Upload · Cancel. Pencere sonuçla kapanır (`bitir`), yüklemeyi çağıran yapar; vazgeçilirse null. Yeni dosya seçimi sonucu
 * dosyanın adından yeniden kurar. Kabul yüklemesinde `ret` alanı gönderilmez (istek bugünküyle aynı).
 */
export function HtYuklemePenceresi({ baslik, bitir }: { baslik: string; bitir: (s: { dosya: File; alanlar: Record<string, string> } | null) => void }) {
  const [dosya, setDosya] = useState<File | null>(null);
  const [sayfa, setSayfa] = useState<SayfaSecimi>(BOS_SAYFA);
  const [sonuc, setSonuc] = useState<HtSonuc>("kabul");
  return (
    <Modal baslik={baslik} onKapat={() => bitir(null)}>
      <div className="flex flex-wrap items-center gap-2">
        <Buton kucuk onClick={async () => { const f = await dosyaSec(".pdf,application/pdf"); if (f) { setDosya(f); setSonuc(ilkHtSonucu(f.name)); } }}>{dosya ? cevir("Change file") : cevir("Select PDF")}</Buton>
        {dosya ? <Cip>📄 {dosya.name}</Cip> : <span className="text-sm text-ink-3">{cevir("not selected")}</span>}
      </div>
      <SayfaAlani deger={sayfa} onChange={setSayfa} />
      <HtSonucAlani deger={sonuc} onChange={setSonuc} ad={dosya?.name} />
      <div className="mt-4 flex gap-2">
        <Buton tur="birincil" disabled={!dosya || !sayfaGecerli(sayfa) || sonuc === ""} onClick={() => { if (dosya) bitir({ dosya, alanlar: { ...sayfaAlanlari(sayfa), ...(sonuc === "ret" ? { ret: "true" } : {}) } }); }}>{cevir("Upload")}</Buton>
        <Buton onClick={() => bitir(null)}>{cevir("Cancel")}</Buton>
      </div>
    </Modal>
  );
}
